<template>
  <div class="upload-cropper">
    <StdUpload
      ref="innerUploader"
      v-bind="$attrs"
      :size="size"
      :isTipOnFail="isTipOnFail"
      :hasLoading="hasLoading"
      :imageUrl="imageUrl"
      :extraData="extraData"
      :accept="accept"
      :on-change="handleUploadChange"
      @uploadComplete="handleUploadComplete"
      @uploadError="handleUploadError"
      @delete="handleDeleteImage"
      @clickImage="clickImage"
      :auto-upload="false"
    >
      <template v-if="$slots.tip" slot="tip">
        <slot name="tip"></slot>
      </template>
    </StdUpload>

    <StdCropper
      ref="innerCropper"
      :ratio="cropperRatio"
      :width="cropWidth"
      :height="cropHeight"
      :currentMode="currentMode"
      @cropComplete="cropComplete"
      @resetUpload="resetUpload"
    ></StdCropper>
  </div>
</template>
<script>
  import {
    buildOssUploadProcessData,
    validImageUpload,
    formatFileSize
  } from '@vhcl/shared/utils/tool';

  export default {
    name: 'UploadCropper',
    components: {
      StdUpload: () => import('./components/StdUpload.vue'),
      StdCropper: () => import('./components/StdCropper.vue')
    },
    props: {
      // 上传失败是否提示
      isTipOnFail: {
        type: Boolean,
        default: true
      },
      imageUrl: {
        type: String
      },
      size: {
        type: String,
        default: 'default'
      },
      cropRatio: {
        type: Number
      },
      cropWidth: {
        type: Number
      },
      cropHeight: {
        type: Number
      },
      currentMode: {
        type: Number
      },
      // 是否启用检测功能
      isCropper: {
        type: Boolean,
        default: true
      },
      // 上传支持类型
      accept: {
        type: String,
        default: 'image/jpg,image/jpeg,image/png,image/gif,image/bmp'
      },
      // 大小限制(单位KB），默认 4096 KB,即4M
      limitSize: {
        type: Number,
        default: 4096
      },
      // 自定义上传base路径
      customBasePath: {
        type: String,
        default() {
          return `interacts/screen-imgs/${dayjs().format('YYYYMM')}`;
        }
      },
      // 上传时是否显示显示loading框
      hasLoading: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        cropData: null,
        upload_process_data: ''
      };
    },
    computed: {
      // 上传图片时附带的额外参数
      extraData() {
        let imageData = {
          path: this.customBasePath,
          type: 'image'
        };
        if (this.upload_process_data) {
          imageData.process = this.upload_process_data;
        }
        return imageData;
      },
      cropperRatio() {
        if (this.size === 'small' && this.cropRatio === undefined) {
          return 1 / 1;
        }
        return this.cropRatio;
      }
    },
    methods: {
      /**
       * 选择图片发生变化触发该事件，弹出剪裁对话框
       * @param {*} file
       * @param {*} fileList
       */
      handleUploadChange(file, fileList) {
        if (file.status == 'ready') {
          const limitOptions = {
            accept: this.accept,
            limitSize: this.limitSize // 大小限制只校验原图，剪裁是在服务端处理的没法校验
          };
          validImageUpload(file.raw, limitOptions, err => {
            if (err === 'type_error') {
              const acceptTip = this.accept.toLowerCase().replace(/image\//g, '');
              this.$vhMessage({
                message: `上传图片只能是 ${acceptTip} 格式`,
                showClose: true,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            } else if (err === 'size_error') {
              this.$vhMessage({
                message: `上传图片大小不能超过${formatFileSize(this.limitSize * 1024)}`,
                showClose: true,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            } else {
              let reader = new FileReader();
              reader.readAsDataURL(file.raw);
              reader.onload = e => {
                if (this.isCropper) {
                  this.$refs.innerCropper.showModel(e.target.result);
                } else {
                  // 直接上传
                  this.$nextTick(() => {
                    this.$refs.innerUploader.upload();
                  });
                }
              };
            }
          });
        }
      },

      // 剪裁完成
      cropComplete(cbData) {
        this.cropData = cbData;
        // 变更上传图片时附带的额外参数
        this.upload_process_data = cbData?.cropperData ? buildOssUploadProcessData(cbData) : '';

        this.$nextTick(() => {
          // 执行上传
          this.$refs.innerUploader.upload();
        });
      },
      // 上传失败
      handleUploadError(err, file, fileList) {
        this.$emit('onUploadError', err, file, fileList);
      },
      // 上传成功
      handleUploadComplete(res, file, fileList) {
        // 文件上传成功，保存信息
        if (res.data) {
          this.$emit(
            'onUploadComplete',
            Object.assign({}, res.data, this.cropData),
            file,
            fileList
          );
        }
      },
      // 删除图片后的事件
      handleDeleteImage() {
        this.$emit('update:imageUrl', '');
        this.$emit('onRemoveImage');
      },
      // 点击图片时触发
      clickImage() {
        this.$emit('onClickImage');
      },
      // 重新上传
      resetUpload() {
        this.$refs.innerUploader.resetChooseFile();
      },
      closeLoading() {
        if (this.$refs.innerUploader?.loadingInstance) {
          this.$refs.innerUploader?.loadingInstance.close();
        }
      }
    }
  };
</script>
